import { formatINR } from '@/utils/format';

export interface TopProductItem {
  id?: string;
  name: string;
  code?: string;
  unitsSold?: number;
  quantity?: number;
  revenue: number;
  margin?: number;
}

interface TopProductsTableProps {
  data?: TopProductItem[];
}

export default function TopProductsTable({ data }: TopProductsTableProps) {
  const products: TopProductItem[] = (data && data.length > 0)
    ? data.map((d) => ({
        name: d.name,
        code: d.code ?? '—',
        unitsSold: Number(d.unitsSold ?? d.quantity ?? 0),
        revenue: Number(d.revenue ?? 0),
        margin: d.margin ?? 35,
      }))
    : [];

  const maxRevenue = products[0]?.revenue ?? 1;

  return (
    <div className="bg-white border border-[#e2e8f0] rounded-xl p-5">
      <h3 className="text-sm font-semibold text-[#1e293b] mb-4">Top 5 Products by Revenue</h3>
      {products.length === 0 ? (
        <div className="py-8 text-center text-xs text-[#94a3b8]">No product sales data recorded yet</div>
      ) : (
        <div className="space-y-3">
          {products.map((p, i) => (
            <div key={p.name + i} className="flex items-center gap-3">
              <span className="w-5 h-5 rounded-full bg-slate-100 flex items-center justify-center text-xs font-bold text-[#64748b] flex-shrink-0">
                {i + 1}
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-0.5">
                  <span className="text-xs font-medium text-[#1e293b] truncate">{p.name}</span>
                  <span className="text-xs text-[#64748b] ml-2 whitespace-nowrap">{p.unitsSold} units</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="flex-1 h-1.5 bg-slate-100 rounded-full overflow-hidden">
                    <div
                      className="h-full bg-emerald-400 rounded-full"
                      style={{ width: `${Math.round((p.revenue / maxRevenue) * 100)}%` }}
                    />
                  </div>
                  <span className="text-xs font-semibold text-emerald-600 whitespace-nowrap">
                    {p.margin}%
                  </span>
                </div>
                <p className="text-xs text-[#94a3b8] mt-0.5">{formatINR(p.revenue)}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
